module.exports = __webpack_public_path__ + "img/background14.650e656d.jpg";